module.exports = __webpack_public_path__ + "img/mobile-elbow-5_74x50.d0495d19.png";